import React,{useState, useEffect} from 'react';
import HeaderStep from '../../../components/HeaderStep/HeaderStep';
import stylesForm from '../Form/Form.module.scss';
import { Input, Form, Select, Spin } from 'antd';
import * as actionTypes from '../../../redux/actions/actionTypes';
import moment from 'moment'
import { useDispatch, useSelector } from 'react-redux';
import getControlloResidenza from '../../../redux/actions/mock/getControlloResidenza';
import Navigation from '../../Navigation/Navigation';
import salvaStep from '../../../redux/actions/mock/salvaStep';

const Residenza = (props) => {

    const datiState = useSelector(state => state.dataReducer);
    const [form] = Form.useForm();
    const loadingStep = useSelector(state => state.dataReducer.load.loadingStep);
    const numPratica = datiState.modello.numPratica;

    const errorMessageControlloCAP = useSelector(state => state.dataReducer.controlloCap.errorMessage);
    const errorCodeControlloCAP = useSelector(state => state.dataReducer.controlloCap.errorCode);

    const apiPath = useSelector(state => state.dataReducer.dataApiPath);
    const loadingResidenza = useSelector(state => state.dataReducer.load.loadingResidenza); 

    const dispatch = useDispatch();

    const erroriSalvaStep = useSelector(state => state.dataReducer.salvaStep.dati);

    const [errorMessageComune, setErrorMessageComune] = useState(null);
    const [errorMessageProvincia, setErrorMessageProvincia] = useState(null);
    const [errorMessageCap, setErrorMessageCap] = useState(null);
    const [errorMessageIndirizzoResidenza, setErrorMessageIndirizzoResidenza] = useState(null);
    const [errorMessageCivico, setErrorMessageCivico] = useState(null);

    useEffect( () => {
        if(erroriSalvaStep){
            erroriSalvaStep.forEach(errore => {
                switch(errore.errorCode) {
                    case "comune":
                        setErrorMessageComune(errore.errorMessage);
                    break;
                    case "provincia":
                        setErrorMessageProvincia(errore.errorMessage);
                    break;
                    case "cap":
                        setErrorMessageCap(errore.errorMessage);
                    break;
                    case "indirizzoResidenza":
                        setErrorMessageIndirizzoResidenza(errore.errorMessage);
                    break;
                    case "civico":
                        setErrorMessageCivico(errore.errorMessage);
                    break;
                    default:
                        setErrorMessageComune(null);
                        setErrorMessageProvincia(null);
                        setErrorMessageCap(null);
                        setErrorMessageIndirizzoResidenza(null);
                        setErrorMessageCivico(null);
                    break;
                }
            }); 
        }else{
            setErrorMessageComune(null);
            setErrorMessageProvincia(null);
            setErrorMessageCap(null);
            setErrorMessageIndirizzoResidenza(null);
            setErrorMessageCivico(null);
        }
    },[erroriSalvaStep]);

    const datiResidenza = useSelector(state => state.dataReducer.controlloResidenza.dati);
    const errorMessageResidenza = useSelector(state => state.dataReducer.controlloResidenza.dati.errorMessage) || null;
    const capResidenza  = useSelector(state => state.dataReducer.modello.datiPratica.cap);
    const comuneResidenza = useSelector(state => state.dataReducer.modello.datiPratica.comune);

    let listaProvinceResidenza = comuneResidenza ? (datiResidenza.comuni)?.filter( singolocomune => {
        return singolocomune.comune === comuneResidenza;
    }) : null;

    function cambioComuneResidenza(element){
        dispatch({ type: actionTypes.COMUNE_RESIDENZA, comune: element });
        const prov = datiResidenza.comuni.find(c => c.comune === element).siglaProvincia;
        form.setFieldsValue({
            provincia: prov
        });
    }

    const { Option } = Select;

    useEffect(()=>{
        if(capResidenza !== null){
            dispatch(getControlloResidenza(capResidenza,apiPath,true));
        }
    },[]); // eslint-disable-line

    useEffect(() => {
        form.setFieldsValue(valoriIniziali());
      },[datiState.modello.datiPratica.abitazione]); // eslint-disable-line

    function controlloCapResidenza(element){
        // Blocca l'inserimento di caratteri non numerici
        if (['e', 'E', '+', '-', '.'].includes(element.key)) {
            element.preventDefault();
            return;
        }
        
        // Limita a 5 cifre
        if(element.target.value.length >= 5 && !['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab'].includes(element.key)){
            element.preventDefault();
            return;
        }
    }

    function onChangeCapResidenza(element){
        const capValue = element.target.value;
        if(capValue.length === 5){
            setErrorMessageComune(null);
            dispatch({ type: actionTypes.LOADING_RESIDENZA_TRUE });
            dispatch({ type: actionTypes.CAP_RESIDENZA, cap: capValue });
            dispatch(getControlloResidenza(capValue,apiPath,false));
            form.setFieldsValue({
                comune:null,
                provincia:null
            });
        }
    }

    function valoriIniziali(){
        let datiRicavati = {};
        const richiesta = datiState.modello.datiPratica || {};
        let nuovaRichiesta= sostituisciDate(richiesta);
        datiRicavati = Object.assign(datiRicavati,nuovaRichiesta);
        return datiRicavati;
      }
  
    function sostituisciDate(obj){
        let step = obj;
        let newStep = {};
        //console.log(`Vecchio step: `,step);
        Object.entries(step).forEach(([chiave,dato]) => {
            if(moment(dato,'YYYY-MM-DD',true).isValid()){
                Object.assign(newStep,{[chiave]:moment(dato,'YYYY-MM-DD')})
            }else if(moment(dato,'YYYY-MM',true).isValid()){
                Object.assign(newStep,{[chiave]:moment(dato,'YYYY-MM')})
            }else{
                Object.assign(newStep,{[chiave]:dato})
            }
        });
        //console.log(`Nuovo step: `,newStep);
        return newStep;
    }

    function sostituisciDateSalvaStep(obj){
      let step = obj;
      let newStep = {};
      Object.entries(step).forEach(([chiave,dato]) => {
        if(moment(dato,'YYYY-MM-DDTHH:mm:ssZ',true).isValid()){
            if(chiave === 'tempoResidenza' || chiave === 'dataInizioAttivita' || chiave === 'dataFineAttivita'){
                Object.assign(newStep,{[chiave]:moment(dato).format('YYYY-MM')});
            } else {
                Object.assign(newStep,{[chiave]:moment(dato).format('YYYY-MM-DD')});
            }
        }else{
            Object.assign(newStep,{[chiave]:dato});
        }
      });
        return newStep;
    }

    function onFinish(values){
        let valoriDaSlavare = values;
        let nuoviValori = sostituisciDateSalvaStep(valoriDaSlavare);
        dispatch({ type: actionTypes.LOADING_TRUE })
        dispatch({ type: actionTypes.SALVA_DATI, payload: nuoviValori})
        dispatch(salvaStep(datiState.modello.datiPratica, datiState.modello.id,datiState.modello.codiceBroker,datiState.modello.currentStep,apiPath,numPratica));
    }

    return (
        <div className={stylesForm.Form}>
            <HeaderStep titolo="Residenza" sottotitolo="" />
            <Form
                form={form}
                onFinish={onFinish}
                initialValues={valoriIniziali()}
            >
                <Form.Item
                    name="indirizzoResidenza"
                    help={errorMessageIndirizzoResidenza}
                    rules={[
                        {
                            required: true,
                            message: "Inserisci indirizzo di residenza",
                        },
                        {
                            max: 50,
                            message: "L'indirizzo non può superare i 50 caratteri",
                        },
                    ]}
                >
                    <Input
                        maxLength={50}
                        placeholder="indirizzoResidenza"
                        suffix={
                            <label
                                className={stylesForm.floatingLabel}
                                htmlFor="indirizzoResidenza"
                            >
                                Indirizzo di residenza*
                            </label>
                        }
                    />
                </Form.Item>

                <div className={stylesForm.leftright}>
                    <div className={stylesForm.left}>
                        <Form.Item
                            name="civico"
                            help={errorMessageCivico}
                            rules={[
                                {
                                    required: true,
                                    message: "Inserisci il numero civico",
                                },
                                {
                                    max: 9,
                                    message: "Il numero civico non può superare i 9 caratteri",
                                },
                            ]}
                        >
                            <Input
                                maxLength={9}
                                placeholder="civico"
                                suffix={
                                    <label
                                        className={stylesForm.floatingLabel}
                                        htmlFor="civico"
                                    >
                                        Numero civico*
                                    </label>
                                }
                            />
                        </Form.Item>
                    </div>
                    <div className={stylesForm.right}>
                        <Form.Item
                            name="cap"
                            help={
                                errorMessageCap ? errorMessageCap :
                                errorCodeControlloCAP === "cap"
                                    ? errorMessageControlloCAP
                                    : errorMessageResidenza
                            }
                            rules={[
                                {
                                    required: true,
                                    message: "Inserisci il CAP",
                                },
                            ]}
                        >
                            <Input
                                type="number"
                                onKeyDown={controlloCapResidenza}
                                onChange={onChangeCapResidenza}
                                minLength={5}
                                maxLength={5}
                                max={99999}
                                placeholder="cap"
                                suffix={
                                    <label
                                        className={stylesForm.floatingLabel}
                                        htmlFor="cap"
                                    >
                                        CAP*
                                    </label>
                                }
                            />
                        </Form.Item>
                    </div>
                </div>

                <Spin spinning={loadingResidenza}>
                    <div className={stylesForm.leftright}>
                        <div className={stylesForm.left}>
                            <Form.Item
                                name="comune"
                                help={
                                    errorCodeControlloCAP === "comune"
                                        ? errorMessageControlloCAP
                                        : errorMessageComune
                                }
                                rules={[
                                    {
                                        required: true,
                                        message: "Inserisci il comune",
                                    },
                                ]}
                            >
                                <Select
                                    placeholder="Comune*"
                                    onChange={cambioComuneResidenza}
                                    >
                                    {datiResidenza &&
                                        datiResidenza.comuni.map((singoloComune) => (
                                        <Option
                                            key={singoloComune.comune}
                                            value={singoloComune.comune}
                                        >
                                            {singoloComune.comune}
                                        </Option>
                                        ))}
                                </Select>

                            </Form.Item>
                        </div>
                        <div className={stylesForm.right}>
                            <Form.Item
                                name="provincia"
                                help={
                                    errorCodeControlloCAP === 'provincia' ?
                                        errorMessageControlloCAP :
                                        errorMessageProvincia
                                }
                                rules={[
                                    {
                                        required: true,
                                        message: 'Inserisci la provincia',
                                    }
                                ]}
                            >
                               <Select placeholder="Provincia*">
                                    {listaProvinceResidenza &&
                                        listaProvinceResidenza.map((singoloComune) => (
                                        <Option
                                            key={singoloComune.siglaProvincia}
                                            value={singoloComune.siglaProvincia}
                                        >
                                            {singoloComune.nomeProvincia}
                                        </Option>
                                    ))}
                                </Select>
                            </Form.Item>
                        </div>
                    </div>
                </Spin>

                <Navigation loadingStep={loadingStep} skip={true} bloccoAvanzamento={errorCodeControlloCAP ? true : false} />
            </Form>
        </div>
    );
}

export default Residenza;